
export default {
    props: {
        value: null
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: event => this.$emit('input', event.target.value)
            };
        },
        filled() {
            return (this.value != null && this.value.toString().length > 0)
        }
    }
}
